import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lpnsqqpinkvzbzhecknk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxwbnNxcXBpbmt2emJ6aGVja25rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM3MDM4NzYsImV4cCI6MjA0OTI3OTg3Nn0.ZUYMmdikxeIbz-lcyOgbPEFsuqbycW7SQ7cU2H7bwWI";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);